import { Work } from '@material-ui/icons';

import { Skeleton } from 'core/cells/skeleton';

import { useGetTermsState } from 'core/memory/apollo/terms/local';

import {
  Card,
  CardBody,
  CardHeader,
  CardIcon,
} from 'templates/mdp/components/card';
import { GridContainer, GridItem } from 'templates/mdp/components/grid';
import { Table } from 'templates/mdp/components/react-table';

import { useStyles } from 'templates/mdp/views/tables/react-tables.styles';

import { createReactTableStore } from 'core/memory/pure/react-table-store';

import { useReactTableState } from 'core/metabolism/table-state';

import { useTasksTableRead } from './use-tasks-table-read';

export const tasksTableStore = createReactTableStore({}, {});

export interface TasksTableProps {
  jobId: string;
}

export const TasksTable = (props: TasksTableProps) => {
  const classes = useStyles();

  const { data: termsState } = useGetTermsState();

  const { columns, data, loading, title } = useTasksTableRead(props.jobId);

  const {
    initialPage,
    pageSize,
    sort,
    filters,
    setSort,
    setFilters,
    setPage,
    setPageSize,
  } = useReactTableState(tasksTableStore);

  return loading || !termsState?.selected ? (
    <Skeleton variant="rect" width="100%" height="80vh" />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Work />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>{title}</h4>
          </CardHeader>
          <CardBody>
            <Table
              noActions
              columns={columns}
              data={data}
              key={termsState?.selected ?? 'unknown_term'}
              onChangeRowsPerPage={setPageSize}
              onChangePage={setPage}
              onFilterChange={setFilters}
              onOrderChange={setSort}
              options={{
                initialPage,
                pageSize,
                sort,
                filters,
              }}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};
